var YTIMES = window.YTIMES || {};
document.documentElement.classList.remove('no-js');

let ytimesFanal_swipers = [];

YTIMES.jsPack = {};

YTIMES.jsPack.cssFiles = [];
YTIMES.jsPack.jsFiles = [];

YTIMES.jsPack.loadEnqueuedFiles = function () {
	if (document.getElementById('deferredCSS')) {
		let deferredCSS = document.getElementById('deferredCSS').textContent.split(';');
		deferredCSS.map(function (url) {
			if(url != '')
				YTIMES.jsPack.enqueueCssFile(url);
		});
	}
	if (document.getElementById('deferredJS')) {
		let deferredJS = document.getElementById('deferredJS').textContent.split(';');
		deferredJS.map(function (url) {
			if(url != '')
				YTIMES.jsPack.enqueueJsFile(url);
		});
	}

    YTIMES.jsPack.cssFiles.forEach(function (url) {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = url;
        document.getElementsByTagName("head")[0].appendChild(link);

    });
	function loadScriptSequentially(urls) {
		if (urls.length === 0) return; // Stop when no more URLs
	
		var script = document.createElement("script");
		script.type = "text/javascript";
		script.defer = true;
		script.src = urls[0]; // Load the first URL
	
		script.onload = function() {
			// Remove the loaded URL from the list
			urls.shift();
			// Recursively load the next script
			loadScriptSequentially(urls);
		};
	
		document.getElementsByTagName("head")[0].appendChild(script);
	}
	
	// Start loading scripts sequentially
	loadScriptSequentially(YTIMES.jsPack.jsFiles.slice());	
};

YTIMES.jsPack.enqueueCssFile = function (url) {
    YTIMES.jsPack.cssFiles.push(url);
};

YTIMES.jsPack.enqueueJsFile = function (url) {
    YTIMES.jsPack.jsFiles.push(url);
};

YTIMES.jsPack.handleInteraction = function() {
    function interactionHandler() {
		window.clearTimeout(YTIMES.jsPack.interactionTimeout);
        document.body.classList.add('interaction');

        window.removeEventListener('scroll', interactionHandler, { passive: true });
        window.removeEventListener('mousewheel', interactionHandler, { passive: true });
        window.removeEventListener('mousemove', interactionHandler, { passive: true });
        window.removeEventListener('click', interactionHandler, { passive: true });
        window.removeEventListener('keydown', interactionHandler, { passive: true });
        window.removeEventListener('touchstart', interactionHandler, { passive: true });
        YTIMES.jsPack.loadEnqueuedFiles();
        YTIMES.jsPack.initLazyImages();
    }
        
    window.addEventListener('scroll', interactionHandler, { passive: true });
    window.addEventListener('mousewheel', interactionHandler, { passive: true });
    window.addEventListener('mousemove', interactionHandler, { passive: true });
    window.addEventListener('click', interactionHandler, { passive: true });
    window.addEventListener('keydown', interactionHandler, { passive: true });
    window.addEventListener('touchstart', interactionHandler, { passive: true });
	YTIMES.jsPack.interactionTimeout = window.setTimeout(interactionHandler, 6000);
}

YTIMES.jsPack.initLazyImages = function() {
    // Check if Intersection Observer is supported
    if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    const card = entry.target;
                    const lazyImage = card.querySelector('img[data-src]');
                    
                    if (lazyImage) {
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.removeAttribute('data-src');
                        
                        // Optional: Add a class when image is loaded
                        lazyImage.onload = function() {
                            lazyImage.classList.add('loaded');
                        };
                    }
                    
                    // Stop observing this card since we've processed it
                    observer.unobserve(card);
                }
            });
        }, {
            // Load images when they're 50px away from entering the viewport
            rootMargin: '50px 0px',
            threshold: 0.01
        });

        // Observe all card elements
        const cards = document.querySelectorAll('.card');
        cards.forEach(function(card) {
            imageObserver.observe(card);
        });
    } else {
        // Fallback for older browsers - load all images immediately
        const lazyImages = document.querySelectorAll('.card img[data-src]');
        lazyImages.forEach(function(img) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
        });
    }
};

document.addEventListener("DOMContentLoaded", function () {
    YTIMES.jsPack.handleInteraction();
//    YTIMES.jsPack.initLazyImages();

	document.body.prepend(document.querySelector('.jump-to-main-content'));

    function viewport() {
        var e = window,
            a = "inner";
        if (!("innerWidth" in window)) {
            a = "client";
            e = document.documentElement || document.body;
        }
        return {
            width: e[a + "Width"],
            height: e[a + "Height"],
        };
    }
    
    // function setEqualHeight() {
    //     const sliders = document.querySelectorAll('.slider');
    //     sliders.forEach(slider => {
    //         const slides = slider.querySelectorAll('.slick-slide');
    //         let maxHeight = 0;
    
    //         // Reset heights
    //         slides.forEach(slide => {
    //             slide.style.height = 'auto';
    //             const slideHeight = slide.offsetHeight;
    //             if (slideHeight > maxHeight) {
    //                 maxHeight = slideHeight;
    //             }
    //         });
    
    //         // Set all slides to the maximum height
    //         slides.forEach(slide => {
    //             slide.style.height = `${maxHeight}px`;
    //         });    
    //     })
    // }

    // setEqualHeight();
    // window.addEventListener('resize', setEqualHeight, { passive: true });
});

//// read more/less
;(() => {
  const CONTENT_SELECTOR = '.read-more';
  const BTN_SELECTOR = '.read-more-btn';
  const EPSILON = 1;

  function setButtonVisible(btn, visible) {
    btn.classList.toggle('is-hidden', !visible);
    btn.tabIndex = visible ? 0 : -1;
    btn.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function getButton(container) {
    const nextSibling = container.nextElementSibling;

    if (nextSibling?.matches(BTN_SELECTOR)) return nextSibling;

    if (nextSibling?.matches('.read-more-btn-container')) {
      const existingButton = nextSibling.querySelector(BTN_SELECTOR);
      if (existingButton) return existingButton;
    }

    const buttonContainer = document.createElement('div');
    const button = document.createElement('button');

    buttonContainer.className = 'read-more-btn-container';
    button.className = 'read-more-btn';
    buttonContainer.append(button);
    container.insertAdjacentElement('afterend', buttonContainer);

    return button;
  }

  function initOne(container, index) {
    if (!container || container.dataset.readMoreInit === 'true') return;

    const desc = container;
    const btn = getButton(container);

    container.dataset.readMoreInit = 'true';

    if (!desc.id) {
      desc.id = 'read-more-' + index;
    }

    btn.type = 'button';
    btn.setAttribute('aria-controls', desc.id);

    const labelMore = btn.dataset.labelMore || 'Read More';
    const labelLess = btn.dataset.labelLess || 'Read Less';

    let isExpanded = false;

    function collapse() {
      isExpanded = false;
      desc.classList.add('is-collapsed');
      desc.classList.remove('is-expanded');
      btn.textContent = labelMore;
      btn.setAttribute('aria-expanded', 'false');
    }

    function expand() {
      isExpanded = true;
      desc.classList.remove('is-collapsed');
      desc.classList.add('is-expanded');
      btn.textContent = labelLess;
      btn.setAttribute('aria-expanded', 'true');
    }

    function isOverflowingWhenCollapsed() {
      const hadExpandedClass = desc.classList.contains('is-expanded');
      const hadCollapsedClass = desc.classList.contains('is-collapsed');

      desc.classList.remove('is-expanded');
      desc.classList.add('is-collapsed');

      const overflowing = desc.scrollHeight - desc.clientHeight > EPSILON;

      if (hadExpandedClass) {
        desc.classList.remove('is-collapsed');
        desc.classList.add('is-expanded');
      } else if (!hadCollapsedClass) {
        desc.classList.remove('is-collapsed');
      }

      return overflowing;
    }

    function recompute() {
        const overflowing = isOverflowingWhenCollapsed();
        setButtonVisible(btn, overflowing);

        if (!overflowing) {
            // Important: remove clamp entirely when text fits
            isExpanded = false;
            desc.classList.remove('is-collapsed', 'is-expanded');
            btn.textContent = labelMore;
            btn.setAttribute('aria-expanded', 'false');
            return;
        }

        if (isExpanded) {
            expand();
        } else {
            collapse();
        }
    }
    btn.addEventListener('click', () => {
      if (btn.classList.contains('is-hidden')) return;
      if (isExpanded) {
        collapse();
      } else {
        expand();
      }
    });

    const ro = new ResizeObserver(() => {
      window.requestAnimationFrame(recompute);
    });

    ro.observe(container);

    window.requestAnimationFrame(recompute);
  }

  function initAll(scope = document) {
    const containers = scope.querySelectorAll(CONTENT_SELECTOR);
    containers.forEach((container, index) => initOne(container, index));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
//// out-of-stock detection: 3rd-party script blacks out .card backgrounds instead of flagging OOS state
;(() => {
  const CARD_SELECTOR = '.card';
  const BLACKOUT_COLORS = new Set(['#000000', '#000', 'rgb(0, 0, 0)', 'rgb(0,0,0)']);

  function isBlackout(color) {
    return !!color && BLACKOUT_COLORS.has(color.trim().toLowerCase());
  }

  function addOosFlag(card) {
    const image = card.querySelector(':scope .image');
    const flagsTop = image?.querySelector(':scope .yfanal-flags-top');
    if (!flagsTop || flagsTop.querySelector(':scope > .yfanal-flag__oos')) return;

    const flag = document.createElement('span');
    flag.className = 'yfanal-flag yfanal-flag__oos';
    flag.textContent = 'out of stock';
    flagsTop.prepend(flag);
  }

  function handleCard(card) {
    const isOos = isBlackout(card.style.backgroundColor) || card.style.opacity !== '';
    if (!isOos) return;

    card.style.backgroundColor = '';
    card.style.opacity = '';
    card.classList.add('oos');
    addOosFlag(card);
  }

  function observeCard(observer, card) {
    handleCard(card);
    observer.observe(card, { attributes: true, attributeFilter: ['style'] });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const cardObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => handleCard(mutation.target));
    });

    document.querySelectorAll(CARD_SELECTOR).forEach((card) => observeCard(cardObserver, card));

    // catch cards added later (e.g. lazy-rendered collection grids)
    const treeObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches(CARD_SELECTOR)) observeCard(cardObserver, node);
          node.querySelectorAll?.(CARD_SELECTOR).forEach((card) => observeCard(cardObserver, card));
        });
      });
    });

    treeObserver.observe(document.body, { childList: true, subtree: true });
  });
})();

//// Product tabs
document.addEventListener("DOMContentLoaded", function () {
    $("h2.tab").each(function () {
        const tab = $(this);

        if (tab.attr('id') != 'tab-product-description') {
            $("#itemTabs ul").append(
                `<li><a href="#${tab.attr("id")}">${tab.text()}</a></li>`
            )
        }
    });
});